import React from 'react'
import './Hackathon.scss'

const Hackathon = () => {
  return (
    <div>Hackathon</div>
  )
}

export default Hackathon